import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

const PersonalFields = ({ user }) => {
  const { first_name: firstName, last_name: lastName, email, profile } = user
  const { phone } = profile
  return (
    <div className="passport-payment-personal-fields">
      <div className="my-3">
        <h3 className="text-lg text-primary-seafoam">Guest Name</h3>
        <p>{`${firstName} ${lastName}`}</p>
      </div>
      <div className="my-3">
        <h3 className="text-lg text-primary-seafoam">Email</h3>
        <p>{email}</p>
      </div>
      <div className="my-3">
        <h3 className="text-lg text-primary-seafoam">Phone Number</h3>
        <p>{phone}</p>
      </div>
    </div>
  )
}

PersonalFields.propTypes = {
  user: PropTypes.object.isRequired,
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
})

export default connect(mapStateToProps)(PersonalFields)
